import Utils from "../../services/Utils.js";
import { updatePrivilege, getChildrenPrivileges, updatePercentage ,updateCashout, updatemaxbetpay, updatesumonhold ,updateRepeatedBet  } from "../../js/api/privileges.js";
import { userData } from "../../js/api/profile.js"
  
let UserConfig = {
    render: async () => {
        const role = localStorage.getItem("role");
        if(['CompanyAdmin', 'SuperAdmin'].indexOf(role) === -1) {
            location.href = '/#/';
            return;
        }
        let request = Utils.parseRequestURL();
        const user = await userData(request.id);
        let userPrivileges = await getChildrenPrivileges(request.id);

        let repeatTicketNumber = user.repeated_bet;
        let singlePercentage = user.single_percentage; 
        let doublePercentage = user.double_percentage; 
        let triplePercentage = user.triple_percentage; 

        let minBet = (Math.floor((parseFloat(user.min_bet) + Number.EPSILON) * 100) / 100).toFixed(2)
        let maxBet = (Math.floor((parseFloat(user.max_bet) + Number.EPSILON) * 100) / 100).toFixed(2)
        let maxPay = (Math.floor((parseFloat(user.max_pay) + Number.EPSILON) * 100) / 100).toFixed(2)

        let sumOnHold = (Math.floor((parseFloat(user.sum_on_hold) + Number.EPSILON) * 100) / 100).toFixed(2)

        let canCashOut = user.can_cash_out

        console.log(canCashOut);

        console.log(user);

        let privilegesView = ``;
        $.each(userPrivileges, function(i,item){
            privilegesView += `
                <div class="privilegesRow" privilege-id="${item.id}">
                    <a class="privilegeName" href="">${item.name}</a>
                    <div class="switchItem ${item.status !== 0 ? 'switched' : ''}">
                        <div class="switchBall"></div>
                    </div>
                </div>
            `
        });

        let view = /*html*/ `  
                <div class="createUsersHeader m-t-6">
                    <a class="backBtn">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                    </a>
                    <span><b>${user.name}</b> bast configuration</span>
                </div>
                <div class="messageShow">
                    <span>You have successfully update configuration!</span>
                </div>
                <div class="configHolder">
                    <div class="configPostion">

                        <div class="accordionWrapper">
                            <div class="accordionHeader">
                                <span>Update Percentage (%)</span>
                            </div>
                            <div class="accordionContent">
                                <div class="accordionRow">
                                    <span class="rowName">Perqindja teke (%)</span>
                                    <input id="singlePercentage" type="number" value="${singlePercentage}" />
                                </div>
                                <div class="accordionRow">
                                    <span class="rowName">Perqindja dyshe (%)</span>
                                    <input id="doublePercentage" type="number" value="${doublePercentage}"  />
                                </div>
                                <div class="accordionRow">
                                    <span class="rowName">Perqindja treshe (%)</span>
                                    <input id="triplePercentage" type="number" value="${triplePercentage}"  />
                                </div>
                                <div class="accordionRow navAccordionBtn">
                                    <a class="saveAccordionBtn updatePercentageBtn">Ruaj</a>
                                </div>
                            </div>
                        </div>

                        <div class="accordionWrapper">
                            <div class="accordionHeader">
                                <span>Update Cashout</span>
                            </div>
                            <div class="accordionContent">
                                <div class="accordionRow">
                                    <span class="rowName">Update Cashout</span>
                                    <div class="switchItem ${canCashOut == '0' ? '' : 'switched'}">
                                        <div class="switchBall"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="accordionWrapper">
                            <div class="accordionHeader">
                                <span>Update MAX BET PAY</span>
                            </div>
                            <div class="accordionContent">
                            <div class="accordionRow">
                                    <span class="rowName">Shuma min e bastit</span>
                                    <input type="text" id="min_bet_val" value="${minBet}"/>
                                </div>
                                <div class="accordionRow">
                                    <span class="rowName">Shuma max e bastit</span>
                                    <input type="text" id="max_bet_val" value="${maxBet}" />
                                </div>
                                <div class="accordionRow">
                                    <span class="rowName">Fitimi max e bastit</span>
                                    <input type="text" id="max_pay_val" value="${maxPay}" />
                                </div>
                                
                                <div class="accordionRow navAccordionBtn">
                                    <a class="saveAccordionBtn" id="maxbetpayBtn">Ruaj</a>
                                </div>
                            </div>
                        </div>

                        <div class="accordionWrapper">
                            <div class="accordionHeader">
                                <span>Update Sum on hold</span>
                            </div>
                            <div class="accordionContent">
                                <div class="accordionRow">
                                    <span class="rowName">Shuma minimale</span>
                                    <input type="number" id="sumonholdval"  value="${sumOnHold}" />
                                </div>
                                <div class="accordionRow navAccordionBtn">
                                    <a class="saveAccordionBtn" id="saveSumOnHold">Ruaj</a>
                                </div>
                            </div>
                        </div>

                        <div class="accordionWrapper">
                            <div class="accordionHeader">
                                <span>Update Repeated Bet</span>
                            </div>
                            <div class="accordionContent">
                                <div class="accordionRow">
                                    <span class="rowName">Sa here mund te perseritet Bileta.</span>
                                    <input type="number" id="repeatTicketNumber" max="7" min="0"  value="${repeatTicketNumber}" />
                                </div>
                                <div class="accordionRow navAccordionBtn">
                                    <a class="saveAccordionBtn" id="saveRepeatTicket">Ruaj</a>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            `;
        return view;
    },
    after_render: async () => {

        
        let request = Utils.parseRequestURL();

        
        $('body').on('click', '.updatePercentageBtn' , async function(e){
            let singlePercentage = $('body #singlePercentage').val();
            let doublePercentage = $('body #doublePercentage').val();
            let triplePercentage = $('body #triplePercentage').val();
            let updatepercentageData = await updatePercentage(singlePercentage,doublePercentage,triplePercentage,request.id);
            $('body .messageShow').addClass('showMessage');
            setTimeout(function(){
                $(e.currentTarget).closest('.accordionWrapper').removeClass('clicked');
                $('body .messageShow').removeClass('showMessage');
            }, 2000);
        });

        $('body').on('click', '#saveRepeatTicket' , async function(e){
            let repeatedTicketValkue = $('body #repeatTicketNumber').val();
            let updatepercentageData = await updateRepeatedBet(request.id,repeatedTicketValkue);
            $('body .messageShow').addClass('showMessage');
            setTimeout(function(){
                $(e.currentTarget).closest('.accordionWrapper').removeClass('clicked');
                $('body .messageShow').removeClass('showMessage');
            }, 2000);
        });

        $('body').on('click', '#saveSumOnHold' , async function(e){
            let price = $('body #sumonholdval').val();
            let updatemaxbetpaydata = await updatesumonhold(price,request.id);
            $('body .messageShow').addClass('showMessage');
            setTimeout(function(){
                $(e.currentTarget).closest('.accordionWrapper').removeClass('clicked');
                $('body .messageShow').removeClass('showMessage');
            }, 2000);
        });

        $('body').on('click', '#maxbetpayBtn' , async function(e){
            let minBet = $('body #min_bet_val').val();
            let maxBet = $('body #max_bet_val').val();
            let maxPay = $('body #max_pay_val').val();
            let updatemaxbetpaydata = await updatemaxbetpay(minBet,maxBet,maxPay,request.id);
            $('body .messageShow').addClass('showMessage');
            setTimeout(function(){
                $(e.currentTarget).closest('.accordionWrapper').removeClass('clicked');
                $('body .messageShow').removeClass('showMessage');
            }, 2000);
        });


        $('body').on('click', '.switchItem', async function(e){

            let privilegeId = $(e.currentTarget).parent().attr('privilege-id');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if($(e.currentTarget).hasClass('switched')){
              $(e.currentTarget).removeClass('switched');
              let updatePrivilegeResponse = await updateCashout(0,request.id);
            }else {
              $(e.currentTarget).addClass('switched');
              let updatePrivilegeResponse = await updateCashout(1,request.id);
            }
            $('body .messageShow').addClass('showMessage');
            setTimeout(function(){
                $(e.currentTarget).closest('.accordionWrapper').removeClass('clicked');
                $('body .messageShow').removeClass('showMessage');
            }, 2000);
        });

        $('body').on('click', '.accordionHeader', async function(e){
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if($(e.currentTarget).parent().hasClass('clicked')){
                $(e.currentTarget).parent().removeClass('clicked');
            }else {
                $(e.currentTarget).parent().addClass('clicked');
            }
        });
        
    },
};

export default UserConfig;
  